import $ from 'jquery';

if (typeof $.type === 'undefined') {
    $.type = function(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };
}


Drupal.behaviors.menuOnScroll = {
  attach: function (context) {
    $(function () {
      let throttleScroll;
      const $header = $('.header', context);
    
      function hasScrolled() {
        let distance = $(window).scrollTop();
    
        if (distance > 140) {
          $header.addClass('scrolled');
        }
        else {
          $header.removeClass('scrolled');
        }
      }
    
      $(document).on('scroll', function () {
        clearTimeout(throttleScroll);
        throttleScroll = setTimeout(function () {
          hasScrolled()
        }, 20);  });
    });
  }
}